import { render, staticRenderFns } from "./BookCourse.vue?vue&type=template&id=5af1f747&scoped=true&"
import script from "./BookCourse.vue?vue&type=script&lang=js&"
export * from "./BookCourse.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5af1f747",
  null
  
)

export default component.exports